export const handleStatusToggle = async ({
  id,
  checked,
  data,
  setData,
  updateApi,
  idField = "id",
  statusField = "isActive",
}) => {
  // Update UI immediately
  const updatedData = data.map((item) =>
    item[idField] === id
      ? { ...item, [statusField]: checked }
      : item
  );

  setData(updatedData);

  try {
    const response = await updateApi(id, checked);
console.log("status",response)
    if (!response?.success) {
      setData(data);
      alert(response?.data.message || "Unable to update status.");
    }
  } catch (err) {
    console.error(err);
    setData(data);
    alert("Something went wrong.");
  }
};